import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import buttons from './ItemsButtons';

export default function ItemsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="items"
			uid={props.model.item_uid}
			avatar={props.model.item_avatar}
			initials={props.model.item_title_initials}
			labelBadge={props.model.itst_title_initials}
			labelBadgeTooltip={props.model.itst_title}
			badgeColor={props.model.itst_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.item_warning_desc && (
								<Tooltip title={props.model.item_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.item_blocked_desc && (
								<Tooltip title={props.model.item_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'items', uid: props.model.item_uid }}
							>
								{props.model.item_title}
							</Text>
						</Grid>
						{/* ERP ID */}
						<Grid>
							{!!props.model.item_erp_id && (
								<SquareChip
									label={
										<FormattedMessage
											id="itemsListItem.erpId"
											defaultMessage={t('ITEMS_ERP_ID')}
											values={{ id: props.model.item_erp_id }}
										/>
									}
								/>
							)}
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.itty_title && (
								<SquareChip label={props.model.itty_title} backgroundColor={props.model.itty_color} />
							)}
						</Grid>
						{/* TAGS */}
						<Grid size={12}>
							<TagsArray tags={props.model.item_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
